import { useEffect, useRef, type ReactNode } from "react";
import { Button } from "./Button";
import { cn } from "./cn";

export function Dialog({
  open,
  onClose,
  title,
  children,
  footer,
  className,
}: {
  open: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
  footer?: ReactNode;
  className?: string;
}) {
  const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (open && !el.open) el.showModal();
    if (!open && el.open) el.close();
  }, [open]);
  return (
    <dialog ref={ref} onClose={onClose} className={cn("bt-dialog", className)} aria-label={title}>
      <div className="bt-dialog__body">
        <div className="bt-dialog__header">
          <h2 className="bt-dialog__title">{title}</h2>
          <Button variant="ghost" size="icon" onClick={onClose} aria-label="✕">
            ✕
          </Button>
        </div>
        <div>{children}</div>
        {footer ? <div className="bt-dialog__footer">{footer}</div> : null}
      </div>
    </dialog>
  );
}
